module.exports = __webpack_public_path__ + "img/reset.ef120c51.png";